import "./App.css";
import axios from "axios";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import ClientPage from "./pages/ClientPage";
import MainPage from "./pages/MainPage";
import NotFound from "./pages/NotFound";
import NotFoundAdmin from "./pages/NotFound";
import ListPage from "./pages/ListPage";
import DetailPage from "./pages/DetailPage";
import BlogPage from "./pages/BlogPage";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";
import CartList from "./pages/CartList";
import ContactPage from "./pages/ContactPage";
import Dashboard from "./components/Admin/dashboard";
import CategoryPage from "./components/Admin/category";
import AdminLogin from "./components/Admin/login";
import UserPage from "./components/Admin/user";
import ImagePage from "./components/Admin/image";
import PostPage from "./components/Admin/post";
import ProductPage from "./components/Admin/product";
import CustomerPage from "./pages/CustomerPage";
import CustomerDashboard from "./components/CustomerDashboard";
import CustomerEdit from "./components/CustomerEdit";
import { CustomerProvider } from "./components/Context/CustomerContext";
import OrderPage from "./components/Order";
import OrderAdminPage from "./components/Admin/order";
import CustomerOrder from "./components/CustomerOrder";
import SupportPage from "./pages/SupportPage";
import NewsPage from "./pages/NewsPage";
import ActiveImagePage from "./pages/ActiveImagePage";
import ContactAdminPage from "./components/Admin/contact";
import CustomerAdminPage from "./components/Admin/customer";
import CouponPage from "./components/Admin/coupon";

axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}`;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["Accept"] = "*/*";
axios.defaults.headers.post["Access-Control-Allow-Origin"] =
  process.env.REACT_APP_CLIENT_URL || "*";
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      delete config.headers["Authorization"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axios.defaults.headers["Shop-Domain"] = process.env.REACT_APP_SHOP_DOMAIN_URL;

function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route
          path="/"
          element={
            <CustomerProvider>
              <ClientPage />
            </CustomerProvider>
          }
        >
          <Route index element={<MainPage />} />
          <Route path="/:slug" element={<ListPage />} />
          <Route path="/:slug/:id" element={<DetailPage />} />
          <Route path="/post/:id" element={<BlogPage />} />
          <Route path="/support/:id" element={<SupportPage />} />
          <Route path="/cart" element={<CartList />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/active-image" element={<ActiveImagePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/client-info" element={<CustomerPage />}>
            <Route index element={<CustomerDashboard />} />
            <Route path="edit-account" element={<CustomerEdit />} />
            <Route path="order" element={<CustomerOrder />} />
          </Route>
          <Route path="/not-found" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminPage />}>
          <Route index element={<Dashboard />} />
          <Route path="category" element={<CategoryPage />} />
          <Route path="contact" element={<ContactAdminPage />} />
          <Route path="customer" element={<CustomerAdminPage />} />
          <Route path="user" element={<UserPage />} />
          <Route path="image" element={<ImagePage />} />
          <Route path="post" element={<PostPage />} />
          <Route path="product" element={<ProductPage />} />
          <Route path="coupon" element={<CouponPage />} />
          <Route path="order" element={<OrderAdminPage />} />
          <Route path="*" element={<NotFoundAdmin />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
